import { isApplicationMode } from '@repo/env-variables';
import { resolveIdempotencyKey } from '@repo/domain-service';
import { createStore, persist } from '@repo/zustand';

interface State {
  email: string;
  cooldownEmail: string;
  resendAvailableAt: number | undefined;
  idempotencyKey: string;

  setEmail: (email: string) => void;
  setCooldown: (date: Date, email: string) => void;
  resolveIdempotencyKey: () => string;
  clearIdempotencyKey: () => void;
  reset: () => void;
}

type PersistedState = Pick<State, 'email' | 'cooldownEmail' | 'resendAvailableAt'>;

const createDefaults = (): Pick<State, 'email' | 'cooldownEmail' | 'resendAvailableAt' | 'idempotencyKey'> => ({
  email: '',
  cooldownEmail: '',
  resendAvailableAt: undefined,
  idempotencyKey: '',
});

export const useAuthFormStore = createStore<State>({
  name: 'AuthFormStore',
  isDev: isApplicationMode('dev'),
})(
  persist(
    (set, get) => ({
      ...createDefaults(),

      setEmail: (email: string) => set({ email, idempotencyKey: '' }),
      setCooldown: (date: Date, email: string) => set({ resendAvailableAt: date.getTime(), cooldownEmail: email }),
      resolveIdempotencyKey: () => {
        const stored = get().idempotencyKey;
        const key = resolveIdempotencyKey(stored);
        if (!stored) set({ idempotencyKey: key });
        return key;
      },
      clearIdempotencyKey: () => set({ idempotencyKey: '' }),
      reset: () => set(createDefaults()),
    }),
    {
      name: 'auth-form-storage-v2',
      partialize: (state): PersistedState => ({
        email: state.email,
        cooldownEmail: state.cooldownEmail,
        resendAvailableAt: state.resendAvailableAt,
      }),
    }
  )
);
